

import React, { useEffect, useState } from "react";
import { Card, Button, Accordion, Container, Row, Col, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import LiveTicker from "../LiveTicker";
import BottomNavbar from "./BottomNavbar";
import { getMyTotalAmount, getUserPositions } from "../../services/apiService";

const Dashboard = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user")) || { name: "User" };

  const [totalAmount, setTotalAmount] = useState(0);
  const [isAssetClassHovered, setIsAssetClassHovered] = useState(false);
  const [positionsData, setPositionsData] = useState([]);
  const [loadingPositions, setLoadingPositions] = useState(true);

  const [totals, setTotals] = useState({
    profit: 0,
    loss: 0,
    net: 0,
    totalPrice: 0,
  });

  const formatAmount = (num) =>
    num?.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const calculateTotals = (data) => {
    let netPL = 0;
    let totalInvestment = 0;

    data.forEach((item) => {
      const investment = item.buy * item.quantity;
      const gain = item.gain || 0; // backend se gain field

      totalInvestment += investment;
      netPL += gain; // positive add, negative subtract
    });

    setTotals({
      profit: netPL >= 0 ? netPL : 0,
      loss: netPL < 0 ? netPL : 0,
      net: netPL,
      totalPrice: totalInvestment,
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const amountData = await getMyTotalAmount();
        setTotalAmount(amountData.totalAmount || 0);
      } catch {
        setTotalAmount(0);
      }

      try {
        setLoadingPositions(true);
        const res = await getUserPositions();

        if (res && Array.isArray(res)) {
          setPositionsData(res);
          calculateTotals(res);
        }
      } catch {
        setPositionsData([]);
        calculateTotals([]);
      } finally {
        setLoadingPositions(false);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <Container fluid className="py-3" style={{ backgroundColor: "#f7f8fc", minHeight: "100vh", paddingBottom: "90px" }}>
        <h4 className="fw-bold mb-4" style={{ textAlign: "start" }}>Hi {user.name} 👋</h4>

        <Card className="shadow-sm mb-4 border-0">
          <Card.Body>
            <h6 className="fw-bold mb-2 text-start">Market Today</h6>
            <LiveTicker />
          </Card.Body>
        </Card>

        <Card className="shadow-sm mb-4 border-0 p-3">
          <div className="d-flex align-items-center mb-3">
            <Button
              variant={isAssetClassHovered ? "primary" : "outline-primary"}
              className="fw-bold px-3 py-1"
              onMouseEnter={() => setIsAssetClassHovered(true)}
              onMouseLeave={() => setIsAssetClassHovered(false)}
            >
              ASSET CLASS
            </Button>
          </div>

          <Row className="align-items-center">
            <Col xs={12} md={7}>
              {loadingPositions ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <>
                  <p className="mb-1 fw-semibold text-secondary">Total Investment</p>
                  <h5 className="fw-bold">₹{formatAmount(totals.totalPrice)}</h5>

                  <p className="mb-1 fw-semibold mt-3 text-secondary">Net Portfolio P&L</p>
                  <h5 className="fw-bold" style={{ color: totals.net >= 0 ? "green" : "red" }}>
                    ₹{formatAmount(totals.net)}
                  </h5>

                  <p className="mb-1 fw-semibold mt-3 text-secondary">Funds Available</p>
                  <h5 className="fw-bold text-primary">₹{formatAmount(totalAmount)}</h5>
                </>
              )}
            </Col>
          </Row>
        </Card>

        <div className="text-center mb-4">
          <Button
            variant="primary"
            size="lg"
            className="rounded px-4 py-2 fw-semibold w-100"
            onClick={() => navigate("/userAccount")}
          >
            ADD / WITHDRAW FUNDS
          </Button>
        </div>

        <Accordion defaultActiveKey="2" className="p-3 mb-5">
          <Accordion.Item eventKey="2">
            <Accordion.Header>
              <span className="d-flex align-items-center gap-2">
                <div style={verticalBarStyle}></div>
                Positions
              </span>
            </Accordion.Header>

            <Accordion.Body className="p-3">
              <Card className="border-0">
                <Card.Body className="p-0">
                  <h6 className="fw-bold mb-3 text-start">Total P&L (Unrealized)</h6>

                  {loadingPositions ? (
                    <div className="text-center">
                      <Spinner animation="border" />
                    </div>
                  ) : (
                    <>
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted small">Funds Available</span>
                        <span className="fw-bold">₹{formatAmount(totalAmount)}</span>
                      </div>

                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted small">Net Profit</span>
                        <span className="fw-bold text-success">₹{formatAmount(totals.profit)}</span>
                      </div>

                      <div className="d-flex justify-content-between">
                        <span className="text-muted small">Net Loss</span>
                        <span className="fw-bold text-danger">₹{formatAmount(totals.loss)}</span>
                      </div>
                    </>
                  )}
                </Card.Body>
              </Card>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Container>

      <BottomNavbar />
    </>
  );
};

const verticalBarStyle = {
  width: "4px",
  height: "20px",
  backgroundColor: "#0d6efd",
  borderRadius: "2px",
};

export default Dashboard;
